import { ValidationsMap } from '../typings';

export const asyncValidationsMapper: ValidationsMap = {};
